import type { StoreApi } from 'zustand'

import { type AuthStoreValuesType } from './auth.store'

import type { PermissionsGroupsEnumType } from '@/features/auth/types'

export async function setAuthTokenAction(
  get: StoreApi<AuthStoreValuesType>['getState'],
  set: StoreApi<AuthStoreValuesType>['setState'],
  authToken: string | null,
) {
  if (!authToken) {
    set({
      authToken: null,
    })
  } else {
    set({
      authToken,
    })
  }
}

export async function clearAuthStoreAction(
  get: StoreApi<AuthStoreValuesType>['getState'],
  set: StoreApi<AuthStoreValuesType>['setState'],
) {
  set({
    authToken: null,
  })
}

export async function setUserActivePermissionGroupAction(
  get: StoreApi<AuthStoreValuesType>['getState'],
  set: StoreApi<AuthStoreValuesType>['setState'],
  userActivePermissionGroup: PermissionsGroupsEnumType | null,
) {
  set({ userActivePermissionGroup })
}
